import Api from "./index";
import { endPoints, requestType } from "../constants/Variables";

export const sendOtpBusinessAccount = (params) => {
  return Api(endPoints.sendOtpBusinessAccount, params, requestType.POST);
};
export const createBusinessAccount = (params) => {
  return Api(endPoints.businessAccount, params, requestType.POST);
};
export const handleLogin = (params) => {
  return Api(endPoints.handleLogin, params, requestType.POST);
};

export const handleLoginAsBusiness = (params) => {
  return Api(endPoints.loginAsBusiness, params, requestType.POST);
};

export const createBusinessBranch = (params) => {
  return Api(endPoints.createBusinessBranch, params, requestType.POST);
};
export const deleteBranch = (id) => {
  return Api(`${endPoints.deleteBranch}/${id}`, null, requestType.POST);
};
export const fetchBusinessBranch = (id) => {
  return Api(`${endPoints.fetchBusinessBranch}/${id}`, null, requestType.GET);
};
export const updateBusinessBranch = (id, params) => {
  return Api(
    `${endPoints.updateBusinessBranch}/${id}`,
    params,
    requestType.POST
  );
};

export const getAdminDetail = () => {
  return Api(endPoints.fetchAdminDetail, null, requestType.GET);
};

//searchClients

export const searchClients = (params) => {
  return Api(endPoints.searchClients, params, requestType.POST);
};

// Create BusinessPro

export const createBusinessPro = (params) => {
  return Api(endPoints.addDetails, params, requestType.POST);
};

export const getSettings = () => {
  return Api(endPoints.getSettings, null, requestType.GET);
};
